(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-article-section-original"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carouselElement = document.querySelector('.article-carousel');
    if (carouselElement) {
      // Initialize Flickity with specific options for better control
      const flkty = new Flickity(carouselElement, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: false, // Disabled wrap around for better control
        groupCells: true,
        cellSelector: '.article-card', // Explicitly tell Flickity what to treat as cells
        adaptiveHeight: false, // Fixed height for stability
        dragThreshold: 10, // More responsive dragging
        selectedAttraction: 0.2, // Smoother transitions
        friction: 0.8,
        imagesLoaded: true // Wait for images to load before initializing
      });

      // Ensure proper layout after all images are loaded
      flkty.on('ready', function() {
        carouselElement.style.opacity = 1;
        flkty.resize(); // Force a resize to ensure proper layout
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-article-section"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carouselElement = document.querySelector('.article-carousel');
    if (carouselElement) {
      // Initialize Flickity with specific options
      const flkty = new Flickity(carouselElement, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: false,
        groupCells: true,
        cellSelector: '.article-card',
        adaptiveHeight: false,
        dragThreshold: 10,
        selectedAttraction: 0.2,
        friction: 0.8,
        imagesLoaded: true
      });

      // Ensure proper layout after images load
      flkty.on('ready', function() {
        carouselElement.style.opacity = 1;
        flkty.resize();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-custom-header"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".collection-header-section");
    if (!section) return;
  
    const button = section.querySelector(".collection-header-section__button");
    const description = section.querySelector(".collection-header-section__description");
  
    if (!button || !description) return;
  
    button.addEventListener("click", function () {
      const isExpanded = description.classList.toggle("expanded");
      description.style.maxHeight = isExpanded ? "none" : "8em";
  
      button.textContent = isExpanded
        ? button.getAttribute("data-read-less")
        : button.getAttribute("data-read-more");
    });
  });

  } catch(e) { console.error(e); }
})();
})();
